import { useMutation, useQueryClient } from "@tanstack/react-query";
import collectionApiClient from "../../../api/collection";

const useChangeSponsoredCodeMutation = () => {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: ({
      collectionId,
      code,
    }: {
      collectionId: string;
      code: string;
    }) => collectionApiClient.changeSponsoredCollectionCode(collectionId, code),
    onSuccess: (_data, variables) =>
      queryClient.refetchQueries({
        queryKey: ["sponsoredCollectionCode", variables.collectionId],
      }),
  });
};

export default useChangeSponsoredCodeMutation;
